import { render, staticRenderFns } from "./PcareConfirmationDialog.vue?vue&type=template&id=0131707b&scoped=true"
import script from "./PcareConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./PcareConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./PcareConfirmationDialog.vue?vue&type=style&index=0&id=0131707b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131707b",
  null
  
)

export default component.exports